import React, { useState } from 'react';
import { Card, Row, Col, Button, Typography, message } from 'antd';
import { CheckCircleTwoTone } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import { API_CONFIG } from '../config/api';

const { Title } = Typography;

function SubjectSelection() {
    const navigate = useNavigate();

    // Default list of subjects
    const subjects = [
        "Math", "General Science", "Social Science", "History",
        "Computer Science", "Medical Science", "Chemistry", "Physics"
    ];

    const [selectedSubjects, setSelectedSubjects] = useState([]);
    const [isLoading, setIsLoading] = useState(false);

    // Toggle subject selection
    const handleSelectSubject = (subject) => {
        setSelectedSubjects(prevSelected =>
            prevSelected.includes(subject)
                ? prevSelected.filter(item => item !== subject) // Deselect
                : [...prevSelected, subject] // Select
        );
    };

    // Submit selected subjects to backend
    const handleSubmitSubjects = async () => {
        if (selectedSubjects.length === 0) {
            message.warning("Please select at least one subject.");
            return;
        }

        setIsLoading(true);
        try {
            const response = await fetch(`${API_CONFIG.BASE_URL}/user/subjects`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${localStorage.getItem('accessToken')}`
                },
                body: JSON.stringify({ subjects: selectedSubjects }),
            });

            if (!response.ok) throw new Error("Failed to update subjects");

            message.success("Subjects updated successfully!");
            navigate('/HomePage');  // ✅ Redirect to HomePage after selection
        } catch (error) {
            message.error(error.message);
        }
        setIsLoading(false);
    };

    return (
        <div style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "100vh",
            background: "linear-gradient(135deg, #e3f2fd, #bbdefb)",
            padding: "20px"
        }}>
            <div style={{ width: "80%", maxWidth: "900px", textAlign: "center" }}>
                <Title level={2} style={{ marginBottom: 30, fontFamily: "Poppins, sans-serif", fontWeight: "bold", color: "#333" }}>
                    Select Your Subjects
                </Title>

                <Row gutter={[16, 16]} justify="center">
                    {subjects.map(subject => (
                        <Col xs={12} sm={8} md={6} key={subject}>
                            <Card
                                hoverable
                                onClick={() => handleSelectSubject(subject)}
                                style={{
                                    borderRadius: "12px",
                                    transition: "0.3s ease-in-out",
                                    background: selectedSubjects.includes(subject) ? "#1890ff" : "white",
                                    color: selectedSubjects.includes(subject) ? "white" : "#333",
                                    border: "1px solid #d9d9d9",
                                    boxShadow: selectedSubjects.includes(subject) ? "0 4px 15px rgba(0, 0, 0, 0.2)" : "0 2px 5px rgba(0, 0, 0, 0.1)",
                                    cursor: "pointer",
                                    fontSize: "16px",
                                    fontWeight: "600",
                                    fontFamily: "Poppins, sans-serif",
                                    padding: "20px",
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                    flexDirection: "column",
                                    width: "150px",  // ✅ Fixed Width
                                    height: "100px",  // ✅ Fixed Height
                                    textAlign: "center",
                                    lineHeight: "1.4"
                                }}
                            >
                                {selectedSubjects.includes(subject) && (
                                    <CheckCircleTwoTone twoToneColor="#ffffff"
                                        style={{ fontSize: "24px", marginBottom: "5px" }} />
                                )}
                                {subject}
                            </Card>
                        </Col>
                    ))}
                </Row>

                <Button
                    type="primary"
                    size="large"
                    style={{
                        marginTop: 30,
                        width: "60%",
                        height: "50px",
                        fontSize: "18px",
                        fontWeight: "bold",
                        borderRadius: "8px",
                        fontFamily: "Poppins, sans-serif",
                        background: selectedSubjects.length > 0 ? "#1890ff" : "#d9d9d9",
                        border: "none",
                        cursor: selectedSubjects.length > 0 ? "pointer" : "not-allowed",
                        transition: "0.3s ease-in-out"
                    }}
                    disabled={selectedSubjects.length === 0 || isLoading}
                    onClick={handleSubmitSubjects}
                >
                    {isLoading ? "Submitting..." : "Continue to Dashboard"}
                </Button>
            </div>
        </div>
    );
}

export default SubjectSelection;
